module.exports = __webpack_public_path__ + "static/media/volleyball.a0aa9a8e.svg";